import { Image } from '../../transports/property-details-page-transport'
import VideoTransport from '../../transports/common/video-transport'
import { TranslationFunction } from '../../common/types'

export interface GalleryImages {
    src: string
    caption: string
    thumbnail: string
}

export class Gallery {
    private static thumbnailSize = 11 // Default thumbnail size

    private __: TranslationFunction
    public images: GalleryImages[] // This will hold the processed images
    public video?: GalleryImages

    /**
     * Constructor to process and store formatted gallery images.
     *
     * @param galleryImages - List of input images with URL and title
     */
    constructor(galleryImages: Image[], translationFunction: TranslationFunction, video?: VideoTransport) {
        this.__ = translationFunction
        this.images = galleryImages.map(image => {
            const imageUrl = image.url
            const processedImage: GalleryImages = {
                src: imageUrl,
                caption: image.title,
                thumbnail: '',
            }

            processedImage.thumbnail = imageUrl.replace(/\/46\//, `/${Gallery.thumbnailSize}/`)

            return processedImage
        })

        this.video = video
            ? {
                  src: video.url,
                  caption: this.__('gallery.virtual') + ' ' + this.__('gallery.tour'),
                  thumbnail: video.thumbnailUrl || '',
              }
            : undefined
    }
}
